import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { EncryptionService } from 'src/app/service/encryption.service';
import { StorageService } from 'src/app/service/storage.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';
@Component({
  selector: 'app-header-search-bar',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './header-search-bar.component.html',
  styleUrls: ['./header-search-bar.component.less']
})

export class HeaderSearchBarComponent {

  searchListArray = [];
  showResults = false;
  isLoggedIn: string;
  mainCategory: string;
  subCategory : string;

  constructor(
    private http: HttpClient,
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private forumApiService: ForumApiService,
    private fb: FormBuilder,
    private encryptionService: EncryptionService,
    private storageService: StorageService,
    private router: Router,
    private dataService: DataService,
    private constantService: ConstantService,
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
  }

  searchForm = this.fb.group({
    searchText: [null],
  });

  get f() {
    return this.searchForm.controls;
  }

  async searchByString(): Promise<void> {
    try {
      const portalId = this.encryptionService.decryptUsingAES_256(
        this.storageService.getItem(this.constantService.portalId)
      );
      const searchStr = this.searchForm.controls.searchText.value;
      const from = this.constantService.searchByStringRequestConstant.from;
      const limit = this.constantService.searchByStringRequestConstant.limit;

      if(this.searchForm.value.searchText == ''){
      this.showResults = false;
      }

      if(this.searchForm.controls.searchText.value != '') {
        await this.forumApiService
        .searchByString(portalId, searchStr, from, limit)
        .then(async (searchByStringResponse) => {
          if(searchByStringResponse.data.length != 0){
            for (let i = 0; i < searchByStringResponse.data.length; i++) {
              this.showResults = true;
              this.searchListArray[i] = searchByStringResponse.data[i];
            }
          } else if(searchByStringResponse.data.length == 0) {
            this.searchListArray = [];
            this.searchListArray[0] = this.constantService.noResultFoundText;
          }
        });
      } else {
        this.searchListArray = [];
      }
      
    } catch (e) {
      console.group('Error Occured in searchByString : ', e);
      this.searchListArray = [];
      this.searchListArray[0] = this.constantService.noResultFoundText;
    }
  }

  goTosubCategoryAnswers(questionId: string, catId: string, questionTitle:string): void {
    this.showResults = false;
    this.dataService.data.subscribe((mainCategoryArray) => {
      mainCategoryArray.forEach(mainCat => {
        mainCat.child.forEach(subCat => {
          if(subCat.id == catId){
            this.mainCategory = mainCat.permalink;
            this.subCategory = subCat.permalink;
          }
        });
      });
    });
    this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
  }

  goToViewTicket(): void {
    this.router.navigateByUrl(this.constantService.navigationComponentPage.viewTicket);
  }

}
